function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod';
import { AccesoDatos, BASE_CANDIDATO_API } from '../../../comun/services/acceso-datos';
var StartMenuComponentCtrl = /*#__PURE__*/function () {
  StartMenuComponentCtrl.$inject = ["$element", "$log", "$timeout", "NotifService", "AccesoDatos"];
  function StartMenuComponentCtrl($element, $log, $timeout, NotifService, AccesoDatos) {
    _classCallCheck(this, StartMenuComponentCtrl);
    _defineProperty(this, "appConfig", null);
    _defineProperty(this, "textosIntro", {
      mostrar: false,
      validos: false,
      porlang: {}
    });
    _defineProperty(this, "textosCv", true);
    _defineProperty(this, "state", {
      menu: null,
      form: null,
      form2: null
    });
    _defineProperty(this, "select", {
      f: null,
      f2: null,
      m: null
    });
    _defineProperty(this, "url_logo_azul_cv", "".concat(BASE_CANDIDATO_API, "images/Logo_Caxton_azul.jpg"));
    this.$element = $element;
    this.$log = $log;
    this.$timeout = $timeout;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(StartMenuComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$log.info('[StartMenuComponentCtrl] onInit', this.params);
      var $menuResource = this.AccesoDatos.menuResource;

      // $menuResource.findAll().then(listResponse => this.list = listResponse)

      this._callbackMenu().then(function (response) {
        _this.list = response.options.root;
        _this.appConfig = response.appconfig;

        // textos de introducción
        _this.textosCv = response.appconfig.introCv;

        // textos modal
        _this.textosIntro.mostrar = response.appconfig.dmesg;
        if (_this.textosIntro.mostrar) {
          if (response.options.intro.es || response.options.intro.en) _this.textosIntro = {
            validos: true,
            mostrar: true,
            porlang: response.options.intro
          };
        }
        $('body').addClass("cand--public cand--public--".concat(_this.appConfig.app));
      });
      if (this.idmenu) {
        this.selectForm({
          idm: this.idmenu
        });
      }
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this2 = this;
      this.$timeout(function () {
        _this2._initModal();
      }, 1000);
    }
  }, {
    key: "_callbackMenu",
    value: function _callbackMenu() {
      if (this.accesoPublico) return this.AccesoDatos.MenuPublicos_CLIENT.menuInicioConfigMenusPublicos();else return this.AccesoDatos.Menu_CLIENT.menuInicioConfigMenusPrivados();
    }
  }, {
    key: "_initModal",
    value: function _initModal() {
      var modalInstance = this.$element.find('#modal-wellcome').modal({
        onCloseEnd: function onCloseEnd() {
          return $('body').removeClass('modal-open').css('overflow', 'auto');
        }
      });

      // si no está no inicializar
      if (!modalInstance.length) return;
      this.modalInstance = M.Modal.getInstance(modalInstance[0]);
      if (this.modalInstance) this.modalInstance.open();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      $('body').removeClass('bg-caxton container-md cand--public');
    }
  }, {
    key: "selectMain",
    value: function selectMain(m1) {
      this.state.menu = m1;
    }
  }, {
    key: "selectForm",
    value: function selectForm(m2) {
      if (this.version == '1') this.selectFormV1(m2);else this.selectFormV2(m2);
    }
  }, {
    key: "selectFormV1",
    value: function selectFormV1(m2) {
      var _this3 = this;
      // leer el formulario
      this._callbackFormV1(m2) //
      .then(function (response) {
        _this3.select.f = response;
        _this3.select.m = m2;
      }) //
      .then(function () {
        return _this3.state.form = m2;
      });
    }
  }, {
    key: "selectFormV2",
    value: function selectFormV2(m2) {
      var _this4 = this;
      // leer el formulario
      this._callbackFormV2(m2) //
      .then(function (response) {
        _this4.select.f2 = response;
        _this4.select.m = m2;
      }) //
      .then(function () {
        return _this4.state.form2 = m2;
      });
    }
  }, {
    key: "_callbackFormV1",
    value: function _callbackFormV1(m2) {
      if (this.accesoPublico) return this.AccesoDatos.FormularPublicos_CLIENT.leerFormularioPublico(m2.idm, m2.idf);else return this.AccesoDatos.Formular_CLIENT.leerFormulario(m2.idm, m2.idf);
    }
  }, {
    key: "_callbackFormV2",
    value: function _callbackFormV2(m2) {
      if (this.accesoPublico) return this.AccesoDatos.FormularPublicos_CLIENT.leerFormularioPublicoDeMenu(m2.idm);else return this.AccesoDatos.Formular_CLIENT.leerFormularioDeMenu(m2.idm);
    }
  }, {
    key: "selectBack",
    value: function selectBack() {
      this.state.form = null;
      this.state.form2 = null;
    }
  }, {
    key: "toggleDev",
    value: function toggleDev() {
      $('body').toggleClass('hide__dev');
    }
  }, {
    key: "closeWellcome",
    value: function closeWellcome() {
      var _this$modalInstance;
      (_this$modalInstance = this.modalInstance) === null || _this$modalInstance === void 0 || _this$modalInstance.close();
    }
  }]);
}();
$candidatoPublicMod.component('startMenu', {
  bindings: {
    // empresa: "<",
    idmenu: '<',
    test: '<',
    params: '<',
    version: '<',
    accesoPublico: '<'
  },
  controller: StartMenuComponentCtrl,
  template: require('./start-menu.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/start-menu/start-menu.component.html"
});